

export function toVideoTime(duration) {
    let result = ''
    let min = Math.floor(duration/60)
    let sec = duration%60
    if (min) {
        result = min + '分'
    }
    if (sec) {
        result += sec + '秒'
    }

    return result;
}

export function toTime(dateString){
    if (!dateString) return ''
    return dateString.replace('T',' ').replace(/\.\d*/,'')
}


